/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from "swiper";
import { Navigation } from "swiper/modules";
Swiper.use([Navigation]);
export function slider() {
    const sliderSelector = ".cards__inner.swiper";
   
    //Fix the tabindex for accebility if the content of the slide is wrapped in an anchor tag
    const handleSlideChangeTransitionEnd = function (swiper) {
        swiper.el
            .querySelectorAll(" .swiper-slide > a")
            .forEach((slide) => {
                slide.setAttribute("tabindex", "-1");
            });

        const activeSlide = swiper.el.querySelector(" .swiper-slide-active > a"
        );
        if (activeSlide != null) {
            activeSlide.setAttribute("tabindex", "0");
        }
    };

    //Makes sure that the lazyloaded image on the duplicate slide has the right class so it doesnt show up as grey
    const handleSlideChange = function () {
        var nextDuplicateSlide = document.querySelector(".swiper-slide-duplicate.swiper-slide-next");
        if (nextDuplicateSlide != null) {
            var unloadedSlideImage = nextDuplicateSlide.querySelector("img.lazyloading");
            if (unloadedSlideImage != null) {
                unloadedSlideImage.classList.replace("lazyloading", "lazyloaded");
            }
        }
    }

    const init = function () {

        //Archive files sliders
        const sliders = [];
        const slidersElements = document.querySelectorAll(sliderSelector);
        if (slidersElements) {
            slidersElements.forEach(slider => {

                sliders.push(new Swiper(slider, {
                    speed: 500,
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                    watchOverflow:true,
                    breakpoints: {
                        992: {
                            enabled: false,
                            slidesPerView: "auto"
                        }
                    },
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            handleSlideChangeTransitionEnd(swiper);
                        }
                    }
                }));
            })
        }
    };

    init();
}
